import { Styles } from "../../../../types/common";

const styles: Styles = {
  detailBox: {
    width: { md: "65%" },
    "& .top_divider": {
      borderTop: "1px dashed #003B4A",
      marginBottom: "25px",
    },
    "& .label_head": {
      color: "#23085A",
      fontSize: "24px",
      fontWeight: "700",
    },
  },
  modalBody: {
    borderRadius: "8px",
    background: "#F0FCF8",
    padding: "16px",
    marginBottom: "28px",
  },
};

export default styles;
